import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 誕生日
 */
export class Birthday extends PrimitiveValueObject<Date> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: Date): Birthday {
    return new Birthday(value);
  }

  /** ラベル */
  static get label(): string {
    return '誕生日';
  }

  /** プレースホルダー */
  static get placeholder(): Date {
    return new Date('2022-01-01');
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /** キー */
  static get key() {
    return 'birthday';
  }

  /** 文字列にする */
  override toString() {
    const d = this.value;
    return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`;
  }

  /**
   * toInputString
   * @returns 文字列
   */
  toInputString() {
    return this.value.toISOString().split('T')[0];
  }
}
